import './mapSection.module.scss';
import { PageSection } from '../PageSection';
import React, { useContext, useEffect, useState } from 'react';
import { OfficialBaseCard } from '../../../components/organisms/bases/OfficialBaseCard';
import { LocationApis } from '../../../apis/locations';
import { TrialLpContext, TrialSectionContext } from '../../../contexts/trial';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { TrialSections } from '../state/TrialResourceState';

export const MapSection = () => {
  const [locations, setLocations] = useState(RemoteResourceV3.loading());
  const context = useContext(TrialLpContext);
  useEffect(() => {
    context.resource.request(TrialSections.MAP, async () => {
      await updateRemoteResourceV3(locations, setLocations, () => LocationApis.findAllBases());
    });
  }, []);
  return (
    <PageSection id="map" title="MAP" subTitle="SHEの拠点について" styleName="map-section">
      <TrialSectionContext.Consumer>
        {({ loaded }) =>
          loaded && (
            <div styleName="bases-wrapper">
              {locations.getOrElse([]).map((location, index) => (
                <OfficialBaseCard key={index} location={location} />
              ))}
            </div>
          )
        }
      </TrialSectionContext.Consumer>
    </PageSection>
  );
};
